import { initSlider } from '../../globals/sliders/slider-util';

export default function () {
    return {
        init() {
            const selector = '.modal-product-slider';
            const sliderConfig = {
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 360,
                        settings: {
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: false,
                            slidesToShow: 3,
                            slidesToScroll: 2
                        }
                    }
                ]
            };

            window.require(['slick'], () => {
                initSlider(selector, sliderConfig);
            });
        }
    };
}
